export const CARD_ID = 'card-number';
export const EXPIRATION_DATE_ID = 'exp-date';
export const POSTAL_CODE_ID = 'zip-code';
export const SECURITY_CODE_ID = 'security-code';
export const COUNTRY_CODE_ID = 'country-code';

const INIT_EMPTY_FIELD = {
  error: '',
  isEmpty: true,
  shouldDisplayError: false,
};

export const STRIPE_CC_FIELDS = {
  [CARD_ID]: INIT_EMPTY_FIELD,
  [EXPIRATION_DATE_ID]: INIT_EMPTY_FIELD,
  [SECURITY_CODE_ID]: INIT_EMPTY_FIELD,
};

export const INIT_EMPTY_CC_FIELDS = {
  ...STRIPE_CC_FIELDS,
  [POSTAL_CODE_ID]: INIT_EMPTY_FIELD,
};
